import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import withRouter from 'Pods/Shared/withRouter'

import CreateProjectForm from './Components/CreateProjectForm'
import Tabs from '../../Shared/Tabs/Tabs'

class ProjectsForm extends React.Component {
  getTabs() {
    const metaSource = this.props.isModal ? 'projects_listing' : this.props.location.search.replace('?meta_source=', '')

    const designerTab = {
      id: 'hire-designer',
      title: 'Hire 3D Designer',
      contents: <CreateProjectForm
        scope="hire-designer"
        username={this.props.match && this.props.match.params && this.props.match.params.username}
        isModal={this.props.isModal}
        metaSource={metaSource}
      />,
    }

    const clientTab = {
      id: 'invite-client',
      title: 'Invite a client',
      contents: <CreateProjectForm
        scope="invite-client"
        username={this.props.match && this.props.match.params && this.props.match.params.username}
        isModal={this.props.isModal}
        metaSource={metaSource}
      />,
    }

    switch (this.props.match && this.props.match.params && this.props.match.params.activeTab) {
      case 'hire-designer':
        return [designerTab]
      case 'invite-client':
        return [clientTab]
      default:
        return [designerTab, clientTab]
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.isModal && (
          <div className="l-inner-compact">
            <h2 className="heading-24">Start a Project</h2>
          </div>
        )}
        <Tabs
          tabs={this.getTabs()}
          activeTabId={this.props.match && this.props.match.params && this.props.match.params.activeTab}
          useContainer
        />
      </Fragment>
    )
  }
}

ProjectsForm.propTypes = {
  isModal: PropTypes.bool,
}

ProjectsForm.defaultProps = {
  isModal: false,
}

export default withRouter(ProjectsForm)
